import {CLEAR_MESSAGE, SET_MESSAGE} from "../actions/types";

const initialState = {};

export default function message(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { code: payload };

    case CLEAR_MESSAGE:
      return { code: "" };

    default:
      return state;
  }
}
